export const WALLPAPER_STORAGE_KEY = 'desktop-wallpaper'

export const WALLPAPERS = [
  {
    id: 'default',
    name: 'ברירת מחדל',
    style: null,
    previewBg: 'linear-gradient(135deg, #f8fafc, #e2e8f0)',
  },
  {
    id: 'blue-grid',
    name: 'רשת כחולה',
    style: {
      backgroundImage: 'radial-gradient(circle, #3b82f6 1px, transparent 1px)',
      backgroundSize: '20px 20px',
    },
    previewBg: 'radial-gradient(circle, #3b82f6 1.5px, transparent 1.5px) 0 0 / 8px 8px',
  },
  {
    id: 'green-waves',
    name: 'גלים ירוקים',
    style: {
      backgroundImage: `repeating-linear-gradient(
        -30deg, transparent, transparent 20px, rgba(34,197,94,0.08) 20px, rgba(34,197,94,0.08) 21px
      ), repeating-linear-gradient(
        30deg, transparent, transparent 20px, rgba(34,197,94,0.06) 20px, rgba(34,197,94,0.06) 21px
      )`,
    },
    previewBg: `repeating-linear-gradient(
      -30deg, transparent, transparent 6px, rgba(34,197,94,0.13) 6px, rgba(34,197,94,0.13) 7px
    ), repeating-linear-gradient(
      30deg, transparent, transparent 6px, rgba(34,197,94,0.1) 6px, rgba(34,197,94,0.1) 7px
    )`,
  },
  {
    id: 'purple-blend',
    name: 'סגול מעורב',
    style: {
      backgroundImage: `radial-gradient(ellipse at 25% 30%, rgba(139,92,246,0.15) 0%, transparent 50%),
        radial-gradient(ellipse at 70% 65%, rgba(168,85,247,0.12) 0%, transparent 50%),
        radial-gradient(ellipse at 50% 15%, rgba(124,58,237,0.1) 0%, transparent 40%)`,
    },
    previewBg: `radial-gradient(ellipse at 30% 30%, rgba(139,92,246,0.3), transparent 60%),
      radial-gradient(ellipse at 70% 70%, rgba(168,85,247,0.25), transparent 60%)`,
  },
  {
    id: 'orange-diamonds',
    name: 'מעוינים כתומים',
    style: {
      backgroundImage: `linear-gradient(45deg, rgba(249,115,22,0.06) 25%, transparent 25%),
        linear-gradient(-45deg, rgba(249,115,22,0.06) 25%, transparent 25%),
        linear-gradient(45deg, transparent 75%, rgba(249,115,22,0.06) 75%),
        linear-gradient(-45deg, transparent 75%, rgba(249,115,22,0.06) 75%)`,
      backgroundSize: '30px 30px',
    },
    previewBg: `linear-gradient(45deg, rgba(249,115,22,0.14) 25%, transparent 25%),
      linear-gradient(-45deg, rgba(249,115,22,0.14) 25%, transparent 25%),
      linear-gradient(45deg, transparent 75%, rgba(249,115,22,0.14) 75%),
      linear-gradient(-45deg, transparent 75%, rgba(249,115,22,0.14) 75%)`,
  },
  {
    id: 'gray-minimal',
    name: 'רשת אפורה',
    style: {
      backgroundImage: `linear-gradient(rgba(100,116,139,0.1) 1px, transparent 1px),
        linear-gradient(90deg, rgba(100,116,139,0.1) 1px, transparent 1px)`,
      backgroundSize: '24px 24px',
    },
    previewBg: `linear-gradient(rgba(100,116,139,0.18) 1px, transparent 1px) 0 0 / 8px 8px,
      linear-gradient(90deg, rgba(100,116,139,0.18) 1px, transparent 1px) 0 0 / 8px 8px`,
  },

  // ── Creative wallpapers ──

  {
    id: 'honeycomb',
    name: 'חלת דבש',
    style: {
      backgroundImage: `linear-gradient(30deg, rgba(234,179,8,0.08) 12%, transparent 12.5%, transparent 87%, rgba(234,179,8,0.08) 87.5%),
        linear-gradient(150deg, rgba(234,179,8,0.08) 12%, transparent 12.5%, transparent 87%, rgba(234,179,8,0.08) 87.5%),
        linear-gradient(30deg, rgba(234,179,8,0.08) 12%, transparent 12.5%, transparent 87%, rgba(234,179,8,0.08) 87.5%),
        linear-gradient(150deg, rgba(234,179,8,0.08) 12%, transparent 12.5%, transparent 87%, rgba(234,179,8,0.08) 87.5%),
        linear-gradient(60deg, rgba(234,179,8,0.06) 25%, transparent 25.5%, transparent 75%, rgba(234,179,8,0.06) 75%),
        linear-gradient(60deg, rgba(234,179,8,0.06) 25%, transparent 25.5%, transparent 75%, rgba(234,179,8,0.06) 75%)`,
      backgroundSize: '40px 70px',
      backgroundPosition: '0 0, 0 0, 20px 35px, 20px 35px, 0 0, 20px 35px',
    },
    previewBg: `linear-gradient(135deg, rgba(234,179,8,0.15), rgba(251,191,36,0.1)),
      linear-gradient(60deg, rgba(234,179,8,0.1) 25%, transparent 25.5%, transparent 75%, rgba(234,179,8,0.1) 75%) 0 0 / 12px 21px`,
  },
  {
    id: 'sunset',
    name: 'שקיעה',
    style: {
      backgroundImage: `radial-gradient(ellipse at 15% 50%, rgba(251,146,60,0.18) 0%, transparent 50%),
        radial-gradient(ellipse at 85% 20%, rgba(244,63,94,0.14) 0%, transparent 45%),
        radial-gradient(ellipse at 50% 90%, rgba(251,191,36,0.12) 0%, transparent 50%),
        radial-gradient(ellipse at 70% 55%, rgba(249,115,22,0.1) 0%, transparent 40%),
        radial-gradient(ellipse at 30% 15%, rgba(252,165,165,0.08) 0%, transparent 35%)`,
    },
    previewBg: `radial-gradient(ellipse at 20% 50%, rgba(251,146,60,0.35), transparent 55%),
      radial-gradient(ellipse at 80% 30%, rgba(244,63,94,0.3), transparent 50%),
      radial-gradient(ellipse at 50% 85%, rgba(251,191,36,0.25), transparent 50%)`,
  },
  {
    id: 'zigzag',
    name: 'זיגזג',
    style: {
      backgroundImage: `linear-gradient(135deg, rgba(6,182,212,0.09) 25%, transparent 25%),
        linear-gradient(225deg, rgba(6,182,212,0.09) 25%, transparent 25%),
        linear-gradient(315deg, rgba(6,182,212,0.09) 25%, transparent 25%),
        linear-gradient(45deg, rgba(6,182,212,0.09) 25%, transparent 25%)`,
      backgroundSize: '40px 20px',
      backgroundPosition: '-20px 0, -20px 0, 0 0, 0 0',
    },
    previewBg: `linear-gradient(135deg, rgba(6,182,212,0.18) 25%, transparent 25%),
      linear-gradient(225deg, rgba(6,182,212,0.18) 25%, transparent 25%),
      linear-gradient(315deg, rgba(6,182,212,0.18) 25%, transparent 25%),
      linear-gradient(45deg, rgba(6,182,212,0.18) 25%, transparent 25%)`,
  },
  {
    id: 'rose-stripes',
    name: 'פסי ורד',
    style: {
      backgroundImage: `repeating-linear-gradient(
        -45deg,
        transparent,
        transparent 8px,
        rgba(244,63,94,0.06) 8px,
        rgba(244,63,94,0.06) 9px,
        transparent 9px,
        transparent 20px,
        rgba(244,63,94,0.04) 20px,
        rgba(244,63,94,0.04) 21px
      )`,
    },
    previewBg: `repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 4px,
      rgba(244,63,94,0.14) 4px,
      rgba(244,63,94,0.14) 5px,
      transparent 5px,
      transparent 10px,
      rgba(244,63,94,0.09) 10px,
      rgba(244,63,94,0.09) 11px
    )`,
  },
  {
    id: 'starfield',
    name: 'שדה כוכבים',
    style: {
      backgroundImage: `radial-gradient(circle at 10% 20%, rgba(99,102,241,0.22) 1px, transparent 1px),
        radial-gradient(circle at 55% 65%, rgba(139,92,246,0.18) 1.5px, transparent 1.5px),
        radial-gradient(circle at 80% 8%, rgba(99,102,241,0.2) 1px, transparent 1px),
        radial-gradient(circle at 35% 82%, rgba(168,85,247,0.15) 0.8px, transparent 0.8px),
        radial-gradient(circle at 92% 48%, rgba(139,92,246,0.2) 1.2px, transparent 1.2px),
        radial-gradient(circle at 22% 52%, rgba(99,102,241,0.14) 0.7px, transparent 0.7px),
        radial-gradient(circle at 68% 38%, rgba(168,85,247,0.18) 1px, transparent 1px),
        radial-gradient(circle at 45% 15%, rgba(124,58,237,0.16) 1.3px, transparent 1.3px),
        radial-gradient(circle at 75% 75%, rgba(99,102,241,0.12) 0.9px, transparent 0.9px)`,
      backgroundSize: '150px 150px',
    },
    previewBg: `radial-gradient(circle at 15% 25%, rgba(99,102,241,0.4) 1.5px, transparent 1.5px),
      radial-gradient(circle at 55% 60%, rgba(139,92,246,0.35) 2px, transparent 2px),
      radial-gradient(circle at 80% 15%, rgba(99,102,241,0.38) 1.5px, transparent 1.5px),
      radial-gradient(circle at 35% 80%, rgba(168,85,247,0.3) 1.2px, transparent 1.2px),
      radial-gradient(circle at 90% 50%, rgba(139,92,246,0.35) 1.8px, transparent 1.8px)`,
  },
]

export function getWallpaperById(id) {
  return WALLPAPERS.find((w) => w.id === id) || WALLPAPERS[0]
}
